module.exports = __webpack_public_path__ + "static/image-flows-96728537b94b68d46a28e16c36226b7a.jpg";